import {gql} from 'apollo-angular';
import {StatusFragment} from "../../fragments/Status";

export const GET_QUIZ_QUESTION = gql`
  query GetQuizQuestion($gameId: Int!, $round: Int!) {
    getQuizQuestion(gameID: $gameId, round: $round){
      status {
        ...statusFields
      }
      id,
      text,
      answers {
        id,
        text
      }
    }
  }
  ${StatusFragment}
`;
